import React, { useEffect, useState } from "react";
import {
    getCashAccounts,
    getArticles,
    getDepartments,
    getCounterparties,
    getDiscounts,
} from "../../utils/dataFetch";
import { SERVER_HOST } from "../../utils/constants";

export default function NewStatementModal({
    toggleModal,
    type = "other",
    fetchData,
    setErrorMessage,
    setSuccessMessage,
    selectedCashAcc = null,
    selectedCounterparty = null,
}) {
    const operations =
        type === "cbAdmission"
            ? [{ id: 9, name: "Інші поступлення" }]
            : type === "cbExpense"
            ? [
                  { id: 3, name: "Передача до каси/на рахунок" },
                  { id: 8, name: "Інші видатки" },
              ]
            : [
                  { id: 1, name: "Оплата постачальнику" },
                  { id: 2, name: "Поступлення від постачальника" },
                  { id: 3, name: "Передача до каси/на рахунок" },
                  { id: 4, name: "Поступлення від покупця" },
                  { id: 8, name: "Інші видатки" },
                  { id: 9, name: "Інші поступлення" },
              ];
    const [cashAccounts, setCashAccounts] = useState([]);
    const [articles, setArticles] = useState([]);
    const [departments, setDepartments] = useState([]);
    const [counterparties, setCounterparties] = useState([]);
    const [discounts, setDiscounts] = useState([]);
    const [relatedData, setRelatedData] = useState([]);
    const [relatedDataLabel, setRelatedDataLabel] = useState("");
    const [amount, setAmount] = useState(
        selectedCounterparty ? selectedCounterparty.debt.toFixed(2) : 0
    );

    const [selectedAccount, setSelectedAccount] = useState("");
    const [selectedArticle, setSelectedArticle] = useState("");
    const [selectedOperation, setSelectedOperation] = useState("");
    const [selectedRelatedData, setSelectedRelatedData] = useState("");
    const [dataError, setDataError] = useState("");

    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                const cashAccountsResult = await getCashAccounts();
                setCashAccounts(cashAccountsResult);
                const articlesResult = await getArticles();
                setArticles(articlesResult);

                if (type !== "sdPayment") {
                    const departmentsResult = await getDepartments();
                    const counterpartiesResult = await getCounterparties();
                    const discountsResult = await getDiscounts();
                    setDepartments(departmentsResult);
                    setCounterparties(counterpartiesResult);
                    setDiscounts(discountsResult);
                }
            } catch (error) {
                setDataError("Помилка завантаження даних!");
            }
        };
        fetchInitialData();

        document.body.classList.add("modal--open");
        return () => {
            document.body.classList.remove("modal--open");
        };
    }, [selectedCashAcc, type]);

    useEffect(() => {
        if (selectedOperation === "1" || selectedOperation === "2") {
            setRelatedData(counterparties);
            setRelatedDataLabel("Контрагент");
        } else if (selectedOperation === "3") {
            setRelatedData(cashAccounts);
            setRelatedDataLabel("Каса/Рахунок");
        } else if (selectedOperation === "4") {
            setRelatedData(discounts);
            setRelatedDataLabel("Клієнт");
        } else if (selectedOperation === "8" || selectedOperation === "9") {
            setRelatedData(departments);
            setRelatedDataLabel("Підрозділ");
        } else {
            setRelatedData([]);
            setRelatedDataLabel("");
        }
    }, [
        selectedOperation,
        counterparties,
        cashAccounts,
        discounts,
        departments,
    ]);

    const handleSubmit = (e) => {
        e.preventDefault();
        addStatementItem();
        toggleModal();
    };

    const addStatementItem = async () => {
        try {
            const response = await fetch(SERVER_HOST, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                credentials: "include",
                body: JSON.stringify({
                    action: "add_statement_item",
                    account: selectedCashAcc
                        ? selectedCashAcc.id
                        : selectedAccount,
                    operation: selectedOperation || 1,
                    correspond: selectedCounterparty
                        ? selectedCounterparty.id
                        : selectedRelatedData,
                    article: selectedArticle,
                    amount: amount,
                }),
            });

            const data = await response.json();
            if (data.status === "success") {
                setSuccessMessage("Операція успішна!");
                setTimeout(() => setSuccessMessage(""), 5000);
            } else {
                setErrorMessage("Сталася помилка при додаванні!");
                setTimeout(() => setErrorMessage(""), 5000);
            }
        } catch {
            setErrorMessage("Сталася помилка при додаванні!");
            setTimeout(() => setErrorMessage(""), 5000);
        }
        fetchData();
    };

    return (
        <div className="modal--backdrop">
            {dataError && (
                <div className="alert alert-danger m-3">{dataError}</div>
            )}
            {!dataError && (
                <div className="modal d-block" tabIndex="-1">
                    <div className="modal-dialog">
                        <div className="modal-content rounded-5">
                            <div className="modal-header">
                                <h5 className="modal-title ms-2">
                                    {type === "cbAdmission"
                                        ? `Нове поступлення `
                                        : type === "cbExpense"
                                        ? `Нова витрата `
                                        : type === "sdPayment"
                                        ? `Оплата постачальнику `
                                        : ""}
                                    {selectedCashAcc && (
                                        <span className="fw-bold">
                                            {selectedCashAcc.name}
                                        </span>
                                    )}
                                    {selectedCounterparty && (
                                        <span className="fw-bold">
                                            {selectedCounterparty.name}
                                        </span>
                                    )}
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close me-0"
                                    onClick={toggleModal}
                                ></button>
                            </div>
                            <div className="modal-body">
                                <form onSubmit={handleSubmit} className="mx-4">
                                    {!selectedCashAcc && (
                                        <div className="row mb-2 d-flex align-items-center">
                                            <label className="col-4 ps-2 pe-0">
                                                Каса:
                                            </label>
                                            <div className="col-8">
                                                <select
                                                    className="form-select form-select-sm rounded-5"
                                                    value={selectedAccount}
                                                    onChange={(e) =>
                                                        setSelectedAccount(
                                                            e.target.value
                                                        )
                                                    }
                                                    required
                                                >
                                                    <option value="" disabled>
                                                        Виберіть касу
                                                    </option>
                                                    {cashAccounts.map(
                                                        (account) => (
                                                            <option
                                                                key={account.id}
                                                                value={
                                                                    account.id
                                                                }
                                                            >
                                                                {account.name}
                                                            </option>
                                                        )
                                                    )}
                                                </select>
                                            </div>
                                        </div>
                                    )}

                                    <div className="row mb-2 d-flex align-items-center">
                                        <label className="col-4 ps-2 pe-0">
                                            Стаття:
                                        </label>
                                        <div className="col-8">
                                            <select
                                                className="form-select form-select-sm rounded-5"
                                                value={selectedArticle}
                                                onChange={(e) =>
                                                    setSelectedArticle(
                                                        e.target.value
                                                    )
                                                }
                                                required
                                            >
                                                <option value="" disabled>
                                                    Виберіть статтю
                                                </option>
                                                {articles.map((article) => (
                                                    <option
                                                        key={article.id}
                                                        value={article.id}
                                                    >
                                                        {article.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>

                                    {selectedCounterparty === null && (
                                        <>
                                            <div className="row mb-2 d-flex align-items-center">
                                                <label className="col-4 ps-2 pe-0">
                                                    Операція:
                                                </label>
                                                <div className="col-8">
                                                    <select
                                                        className="form-select form-select-sm rounded-5"
                                                        value={
                                                            selectedOperation
                                                        }
                                                        onChange={(e) =>
                                                            setSelectedOperation(
                                                                e.target.value
                                                            )
                                                        }
                                                        required
                                                    >
                                                        <option
                                                            value=""
                                                            disabled
                                                        >
                                                            Виберіть операцію
                                                        </option>
                                                        {operations.map(
                                                            (op) => (
                                                                <option
                                                                    key={op.id}
                                                                    value={
                                                                        op.id
                                                                    }
                                                                >
                                                                    {op.name}
                                                                </option>
                                                            )
                                                        )}
                                                    </select>
                                                </div>
                                            </div>

                                            {selectedOperation &&
                                                relatedData.length > 0 && (
                                                    <div className="row mb-2 d-flex align-items-center">
                                                        <label className="col-4 ps-2 pe-0">
                                                            {relatedDataLabel}
                                                        </label>
                                                        <div className="col-8">
                                                            <select
                                                                className="form-select form-select-sm rounded-5"
                                                                value={
                                                                    selectedRelatedData
                                                                }
                                                                onChange={(e) =>
                                                                    setSelectedRelatedData(
                                                                        e.target
                                                                            .value
                                                                    )
                                                                }
                                                                required
                                                            >
                                                                <option
                                                                    value=""
                                                                    disabled
                                                                >
                                                                    Виберіть
                                                                </option>
                                                                {relatedData.map(
                                                                    (item) => (
                                                                        <option
                                                                            key={
                                                                                item.id
                                                                            }
                                                                            value={
                                                                                item.id
                                                                            }
                                                                        >
                                                                            {
                                                                                item.name
                                                                            }
                                                                        </option>
                                                                    )
                                                                )}
                                                            </select>
                                                        </div>
                                                    </div>
                                                )}
                                        </>
                                    )}

                                    <div className="row mb-2 d-flex align-items-center">
                                        <label className="col-4 ps-2 pe-0">
                                            Сума:
                                        </label>
                                        <div className="col-8">
                                            <input
                                                type="number"
                                                className="form-control form-control-sm rounded-5"
                                                value={amount}
                                                onChange={(e) =>
                                                    setAmount(e.target.value)
                                                }
                                                required
                                            />
                                        </div>
                                    </div>

                                    <div className="row d-flex justify-content-center mb-2">
                                        <button
                                            type="submit"
                                            className="btn btn-sm main--button w-auto text-white mt-3"
                                        >
                                            {type === "sdPayment"
                                                ? "Оплатити"
                                                : "Додати"}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
